import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

// Label above value, for the narrow staff rail: a label column beside the
// value squeezed long values (URLs, user agents) into a sliver.
export function DetailList({ children, className }: { children: ReactNode; className?: string }) {
  return <dl className={cn('space-y-2.5', className)}>{children}</dl>
}

export function DetailItem({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="min-w-0">
      <dt className="text-etn-micro text-etn-text-label">{label}</dt>
      <dd className="mt-0.5 min-w-0 text-etn-control text-etn-text-cell">{children}</dd>
    </div>
  )
}
